module.exports = __webpack_public_path__ + "img/empty-cart.5aae40a1.png";